import { render, staticRenderFns } from "./ExpertsAnswer.vue?vue&type=template&id=a99bbfd8&scoped=true"
import script from "./ExpertsAnswer.vue?vue&type=script&lang=js"
export * from "./ExpertsAnswer.vue?vue&type=script&lang=js"
import style0 from "./ExpertsAnswer.vue?vue&type=style&index=0&id=a99bbfd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99bbfd8",
  null
  
)

export default component.exports